function removeLink(url: string) {
  const existingLink = document.body.querySelector(`link[href='${url}'`);
  if (existingLink) {
    existingLink.remove();
  }
}

export function preloadFiles(urls: string[]) {
  for (let i = 0; i < urls.length; i++) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', 'fetch');
    link.setAttribute('crossorigin', 'anonymous');
    link.setAttribute('href', urls[i]);
    link.onload = () => removeLink(urls[i]);
    document.body.appendChild(link);
  }
}
